import * as Styles from './List.styles';
import React from 'react';
import { ListItem } from './components/ListItem';
import { Tag } from 'gatorcomponents';

const List = ({
  available,
  searchedDomain,
  locales,
  domainsList,
  freeDomains,
  checkedItems,
  setCheckedItems,
}) => (
  <Styles.ListWrapper>
    {(!available && !!domainsList.length) && (
      <ListItem
        available={false}
        searchedDomain={searchedDomain}
        locales={locales}
        freeDomains={freeDomains}
        checkedItems={checkedItems}
        setCheckedItems={setCheckedItems}
      />
    )}

    {domainsList.map((domain) => {
      const keys = Object.keys(domain.cycle);
      const values = Object.values(domain.cycle);

      const options = keys.map((key, index) => ({
        value: key,
        label: (
          <>
            {`${locales.optionsCycle[key]} ${locales.optionsCycle.year(locales.optionsCycle[key])}`}
            <Tag variant="active" size="sm" label={`${values[index].discount}% OFF`} />
          </>
        ),
      }));

      const protectIdData = domain.related && domain.related[0];

      return (
        <React.Fragment key={domain.name}>
          <ListItem
            available
            domain={domain}
            locales={locales}
            freeDomains={freeDomains}
            checkedItems={checkedItems}
            setCheckedItems={setCheckedItems}
            options={options}
            protectIdData={protectIdData}
          />
        </React.Fragment>
      );
    })}
  </Styles.ListWrapper>
);

export default List;
